/* eslint-disable camelcase */
import { PlotGroupFiltersEnum } from '@/api/rest/resources/types/plotGroup';
import { useActivePlotGroup } from '@/components/PlotGroups/PlotGroupsContextProvider';
import { useOrganizationId } from '@/pages/shared/hooks/useOrganizationId';
import { useOrganizationPlotGroups } from '@/pages/shared/hooks/useOrganizationPlotGroup';

export const usePlotGroupFilterStartYear = (plotGroupId?: string) => {
  const { filters } = useActivePlotGroup();
  const orgId = useOrganizationId();
  const plotGroups = useOrganizationPlotGroups(orgId).data;

  if (plotGroupId) {
    const plotGroup = plotGroups?.find((pg) => pg.id === plotGroupId);
    const startDateFilters = plotGroup?.filter_definition?.field_filters?.find(
      (f) => f.field === PlotGroupFiltersEnum.start_date,
    );

    if (startDateFilters?.value) {
      return new Date(startDateFilters.value).getFullYear();
    }
  }

  const { start_date } = filters;

  if (!start_date) {
    return undefined;
  }

  return new Date(start_date).getFullYear();
};
